import React from 'react';
import Api from 'models/Api';

export interface WebglAppConfig {
  data: string;
  framework: string;
  loader: string;
  wasm: string;
  version: string;
}

export class WebglAppApi {
  /**
   * Fetch the urls for the webgl app these urls can be called to get the app
   * @param user_id if null return null
   * @returns an object containing the urls required to get the webgl unity app
   */
  public static latest(user_id: number | null): Promise<WebglAppConfig | null> {
    if (user_id == null) {
      return Promise.resolve<WebglAppConfig | null>(null);
    }
    return Api.get('/webgl_app/latest')
      .then(response => response.json());
  }
}
